import { SvgIcon } from '@mui/material';

const OutlookIcon = () => (
  <SvgIcon fontSize="medium" sx={{ marginRight: '0.313rem' }}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="1.563rem" height="1.563rem">
      <path
        fill="#03A9F4"
        d="M21,31c0,1.104,0.896,2,2,2h17c1.104,0,2-0.896,2-2V16c0-1.104-0.896-2-2-2H23c-1.104,0-2,0.896-2,2V31z"
      />
      <path
        fill="#B3E5FC"
        d="M42,16.975V16c0-0.428-0.137-0.823-0.367-1.148l-11.264,6.932l-7.542-4.656L22.125,19l8.459,5L42,16.975z"
      />
      <path fill="#0277BD" d="M27 41.46L6 37.46 6 9.46 27 5.46z" />
      <path
        fill="#FFF"
        d="M21.216,18.311c-1.098-1.275-2.546-1.913-4.328-1.913c-1.892,0-3.408,0.669-4.554,2.003c-1.144,1.337-1.719,3.088-1.719,5.246c0,2.045,0.564,3.714,1.69,4.986c1.126,1.273,2.592,1.91,4.378,1.91c1.84,0,3.331-0.652,4.474-1.975c1.143-1.313,1.712-3.043,1.712-5.199C22.869,21.281,22.318,19.595,21.216,18.311z M19.049,26.735c-0.568,0.769-1.339,1.152-2.313,1.152c-0.939,0-1.699-0.394-2.285-1.187c-0.581-0.785-0.87-1.861-0.87-3.211c0-1.336,0.289-2.414,0.87-3.225c0.586-0.81,1.368-1.211,2.355-1.211c0.962,0,1.718,0.393,2.267,1.178c0.555,0.795,0.833,1.895,0.833,3.31C19.907,24.906,19.618,25.968,19.049,26.735z"
      />
    </svg>
  </SvgIcon>
);

export default OutlookIcon;
